import { Icons } from './icons';
import { Images } from './images';

export const CLOUDFRONT_LANDING_PAGE_ROOT_URL = 'https://d2rwz7a7lb9mw2.cloudfront.net/landingpage';

export const platforms = {
  ios: 'ios',
  android: 'android',
  iosX: 'iosX',
};

export const benefits = [
  {
    name: 'ic1',
    url: `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/ic_benefit1.svg`,
  },
  {
    name: 'ic2',
    url: `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/ic_benefit3.svg`,
  },
  {
    name: 'ic3',
    url: `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/ic_benefit2.svg`,
  },
  {
    name: 'ic4',
    url: `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/ic_benefit4.svg`,
  },
  {
    name: 'ic5',
    url: `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/ic_benefit5.svg`,
  },
  {
    name: 'ic6',
    url: `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/ic_benefit6.svg`,
  },
  {
    name: 'ic7',
    url: `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/ic_benefit7.svg`,
  },
];

export const VARIATIONS = {
  normal: 'normal',
  vip_journey: 'vip journey',
  alshabab: 'vip_journey_alshabab',
  limited_time_offer: 'limited_time_offer',
  limited_time_offer_v2: 'limited_time_offer_v2',
  tv: 'tv',
  mobile_arts: 'mobile_arts',
  ab_test_a: 'inapp_v1',
  ab_test_b: 'inapp_v2',
};

export const AB_TEST_VERSIONS = {
  unique_variation_a: 'inapp_v1',
  unique_variation_b: 'inapp_v2',
};

export const PAYMENT_METHODS = {
  dcb: 'dcb',
  applepay: 'applepay',
  googlepay: 'googlepay',
};

export const checkVersion = (versionToCheck: string | null, requestVersion: string | null): boolean => {
  if (!requestVersion) {
    return false;
  }
  if (!versionToCheck) {
    return false;
  }

  const currentVersion = requestVersion.split('.');
  const versionProvided = versionToCheck.split('.');

  let canContinue = true;

  for (let index = 0; index < versionProvided.length; index++) {
    const element = currentVersion?.[index] ? +currentVersion[index] : 0;
    const providedElement = versionProvided?.[index] ? +versionProvided[index] : 0;

    if (providedElement < element) {
      canContinue = true;
      break;
    } else if (providedElement > element) {
      canContinue = false;
      break;
    } else {
      canContinue = true;
    }
  }

  return canContinue;
};

export const UNIQUE_VARIATION_2_PLAN_CARD_MAP = {
  monthly: {
    key: 0,
    banner: Images.unique_variation_2_banner_3,
    offerBadge: Icons.blue_medal_u,
    offerBadgeText: 'month_ab_off',
    planTextPrimary: 'month_ab',
    planPrice: '8.4',
    planTextSecondary: 'month_slash',
  },
  quarterly: {
    key: 1,
    banner: Images.unique_variation_2_banner_2,
    offerBadge: Icons.blue_fire_u,
    offerBadgeText: 'month_3_ab_off',
    planTextPrimary: 'month_3_ab',
    planPrice: '24',
    planTextSecondary: 'month_3_slash',
  },
  yearly: {
    key: 2,
    banner: Images.unique_variation_2_banner_1,
    offerBadge: Icons.blue_diamond_u,
    offerBadgeText: 'yearly_ab_off',
    planTextPrimary: 'yearly_ab',
    planPrice: '60',
    planTextSecondary: 'year_slash',
  },
};
